import React, { useState } from 'react'
import cn from 'classnames'
import { thumbnailUrl } from './thumbnail-url'
import styles from './FeatureCard.module.scss'

// Resized copy first, the original once if that fails; fades in when loaded.
// Callers key it by src so a new image starts over.
const ThumbImage = ({ src, width, alt, className }) => {
  const [useOriginal, setUseOriginal] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const thumb = thumbnailUrl(src, width)
  const fallBack = () => {
    if (useOriginal || thumb === src) return
    setLoaded(false)
    setUseOriginal(true)
  }

  return (
    <img
      src={useOriginal ? src : thumb}
      alt={alt}
      loading='lazy'
      className={cn(styles.thumb, className, { [styles.loaded]: loaded })}
      // A cached error response can fire load with no pixels; treat it as a failure.
      onLoad={(event) => (event.currentTarget.naturalWidth ? setLoaded(true) : fallBack())}
      onError={fallBack}
    />
  )
}

export default ThumbImage
